// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--qL1jW";
export var button = "styles-module--button--Jy7YR";
export var c_card = "styles-module--c_card--QeXfj";
export var card_content = "styles-module--card_content--udu6v";
export var figure = "styles-module--figure--EHdiN";
export var tag = "styles-module--tag--d8LCe";
export var text_content = "styles-module--text_content--I24m1";
export var title = "styles-module--title--kQLjA";